import React from 'react';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { WorksheetAssociatedTestSection } from 'Components/Worksheets/Core';

const Section: React.FC<IWorksheetComponent> = () => {
  return (
    <WorksheetAssociatedTestSection
      name="EmbeddedWaterContent.MoistureContentTest"
      testType="Moisture Content"
      heading="Passing 20mm As-Received Water Content (BS EN ISO 17892-1)"
      associatedTestModel={{
        measured: true,
      }}
      disabled={true}
    />
  );
};

const BsEmbeddedWaterContent = withInjectedProps(Section);

export { BsEmbeddedWaterContent };
export default BsEmbeddedWaterContent;
